import React from "react";

/* =======================
   Styles
======================= */
import styles from "./UserStatusBadge.module.scss";

const UserStatusBadge = ({ status = "" }) => {
  // Normalize string to ensure consistent mapping
  const normalizedStatus = String(status).toUpperCase();

  // Map the status to our specific BEM modifier class
  const getStatusModifier = () => {
    switch (normalizedStatus) {
      case "ACTIVE":
        return styles["admin-status-badge--active"];
      case "INACTIVE":
        return styles["admin-status-badge--inactive"];
      case "PENDING":
        return styles["admin-status-badge--pending"];
      default:
        // Default fallback if an unknown status is passed
        return styles["admin-status-badge--active"];
    }
  };

  return (
    <span className={`${styles["admin-status-badge"]} ${getStatusModifier()}`}>
      {normalizedStatus}
    </span>
  );
};

export default UserStatusBadge;
